module.exports = __webpack_public_path__ + "static/media/1f910.445d6244.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/emoji/1f910.svg
// module id = 649
// module chunks = 1